import { getModuleEnvironment } from '@grabjs/mobile-kit-bridge-sdk';

const NativeModule = ['AuthModule', 'RTCModule'];

export const inGrabApp = () =>
  /grab/i.test(window.navigator.userAgent) ||
  NativeModule.find(moduleName => getModuleEnvironment(window, moduleName)) !==
    undefined;

// Check if the user-agent contains mobile device
// e.g. Android user-agent: Grab/5.268.0 (Android 12; Build 0)
export const isMobile = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    window.navigator.userAgent,
  );

export default {};
